import { render, staticRenderFns } from "./productPage.vue?vue&type=template&id=4f9ec3df&"
import script from "./productPage.vue?vue&type=script&lang=ts&"
export * from "./productPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../wellness/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports